import React, {memo, ReactNode} from 'react';
import './index.scss';

type Props = {
    children?: ReactNode;
    min: number;
    max: number;
    innerWidth: number;
};

export const ColumnComponent = memo(function ColumnComponent({children, min, max, innerWidth}: Props) {
    let className = 'appColumn';

    if (innerWidth > 600) {
        className += ` col-${min}`;
    } else {
        className += ` col-${max}`;
    }

    return (
        <div className={className}>
            {children}
        </div>
    );
});
